import { environment } from "../../../environments/environment";

export default function getImageUrl(item: any){
  if (item instanceof File) {
    const result = URL.createObjectURL(item)

    return result
  }

  const baseUrl = environment.serverHost.substring(0, environment.serverHost.length - 1);
  if (item && item.url) {
    let url = item.url;
    if (!url.startsWith('http')) {
      url = baseUrl + url;
    }
    return url;
  } else if (item) {
    let url = item;
    if (!url.startsWith('http')) {
      url = baseUrl + url;
    }
    return url;
  }
}
